export const enGb = {
  add: "Add",
  accountIdentifier: "Account identifier",
  active: "Active",
  activate: "Activate",
  activateCustomer: "Activate customer",
  activateCustomerDescription:
    "Are you sure you want to activate customer account? The Customer will be able to access Fuzebox and process transactions once integration is set.",
  activatingYourBeneficiaryWillMean:
    "Activating your beneficiary will mean you will be able to accept payments through Volt into that account?",
  activateOn: "Activate on",
  activeProducts: "Active products",
  addAddress: "Add address",
  addAddressToCustomer: "Add address to customer",
  addADynamicBeneficiary: "Add a Dynamic Beneficiary",
  addANewCustomer: "Add a new customer",
  addBeneficiary: "Add Beneficiary",
  addBeneficiary_plural: "Add {{count}} Beneficiaries",
  addCustomer: "Add customer",
  addDynamicBeneficiary: "Add Dynamic Beneficiary",
  addedBy: "Added by",
  addEntry: "Add Entry",
  addNewDynamicBeneficiaries: "Add new dynamic beneficiaries",
  address: "Address",
  addressLine2: "Address line 2",
  aliasValue: "Alias Value",
  atMidnight: "at 23:59 UTC",
  allOfTheRealBankAccountsPopulated:
    "All of the real bank accounts have Bank Name populated.",
  applyFilters: "Apply filters",
  applyFiltersBeforeClose:
    "Before you close down the filter, do you want to leave without applying your filters?",
  areYouSureYouWantToChangeStatus:
    "Are you sure you want to change the status?",
  areYouSureYouWantToDeactivateCustomer:
    "Are you sure you want to deactivate customer account? The Customer will no longer be able to process transactions and access Fuzebox after the deactivation date.",
  areYouSureYouWantToStopCustomerDeactivation:
    "Are you sure you want to stop the customer deactivation? The Customer will be able to continue as normal.",
  authorized: "Authorized",
  backToList: "Back to all customers",
  bankCode: "Bank Code",
  beforeConfiguringSettlement:
    "Before configuring settlement for Brazil all of following must be validated",
  brazilSettlement: "Brazil settlement",
  buildingNumber: "Building number",
  bySelectingAccountOutsideBrazil:
    "By selecting a bank account outside Brazil, you are registering this merchant's bank account at BEXS and setting the settlement to crossborder.",
  bySelectingBrazilianAccount:
    "By selecting a brazilian bank account, you are setting this merchant to domestic settlement.",
  cancel: "Cancel",
  cashManagement: "Cash Management",
  changeDeactivationDate: "Change deactivation date",
  childCustomers: "Child customers",
  checkoutBranding: "Checkout branding",
  city: "City",
  circuitBreaker: "Circuit Breaker",
  circuitBreakerHasBeenActivated: "Circuit Breaker has been activated",
  circuitBreakerHasBeenDeactivated: "Circuit Breaker has been deactivated",
  circuitBreakerMonitorsEveryTransaction:
    "Circuit Breaker monitors every transaction, using a flexible scoring system and responsive fraudster detection, to catch the fraud before it catches you.",
  clear: "Clear",
  clearingOptimisation: "Clearing Optimisation",
  clearingOptimisationTooltip:
    "Optimise your settlement rate by processing payments only via banks that Volt identifies as having high clearing rates",
  clientId: "Client ID",
  clientSecret: "Client Secret",
  close: "Close",
  companyRegistrationNumber: "Company registration number",
  configure: "Configure",
  configurePaymentsProviders: "Configure payments providers",
  confirm: "Confirm",
  continue: "Continue",
  couldNotFetchAccountInfos: "Could not fetch account informations.",
  couldNotLoadProviderConfiguration: "Could not load payment providers.",
  couldNotLoadSettlementPreferences: "Could not load settlement preferences.",
  countries: "Countries",
  countriesHaveBeenUpdated: "Countries have been updated",
  country: "Country",
  credentials: "Credentials",
  customer: "Customer",
  customerActivated: "Customer activated",
  customerAddress: "Customer address",
  customerDeactivated: "Customer deactivated",
  customerDetails: "Customer details",
  customerAcceptsPayments: "Customer accepts payments from selected countries",
  customerAddressIsProvided: "Customer address is provided.",
  customerName: "Customer {{name}}",
  customers: "Customers",
  customerStatus: "Customer status",
  customerStatusEnabled:
    "Enabled - customer can access the Fuzebox and make payments",
  customerStatusDisabled:
    "Disabled - customer cannot access the Fuzebox and also cannot make payments",
  customerType: "Customer Type",
  chooseDeactivationDate: "Choose deactivation date",
  dateAdded: "Date added",
  deactivate: "Deactivate",
  deactivateCustomer: "Deactivate customer",
  areYouSureDeactivateCustomer:
    "Are you sure you want to deactivate customer account? The Customer will no longer be able to process transactions and access Fuzebox.",
  deactivatingYourBeneficiaryWillMean:
    "Deactivating your beneficiary will mean you will no longer be able to accept payments through Volt into that account?",
  deactivationDate: "Deactivation Date",
  documentNumber: "Document number",
  dynamicBeneficiaries: "Dynamic Beneficiaries",
  dynamicBeneficiariesHaveBeenUpdated: "Dynamic beneficiary has been updated",
  dynamicBeneficiariesHaveBeenUpdated_plural:
    "Dynamic beneficiaries have been updated",
  dynamicBeneficiariesUpdateFailed: "Dynamic beneficiaries update failed.",
  dynamicBeneficiariesWereUpdated: "Dynamic beneficiaries have been updated.",
  dynamicBeneficiary: "Dynamic beneficiary",
  doNotApplyFilters: "Don’t apply",
  edit: "Edit",
  editAddress: "Edit address",
  editCustomer: "Edit customer",
  environment: "Environment",
  failedToLoadUsernames: "Failed to load usernames. Please, try again later.",
  findOutMore: "Find out more",
  gateway: "Gateway",
  generalInformation: "General information",
  generate: "Generate",
  givenCustomerCouldNotBeFound: "Given customer could not be found.",
  filter: "Filter",
  globalFilter: "Global Filter",
  globalFilterHasBeenReset: "Global filter has been reset",
  goToBeneficiaries: "Go to Beneficiaries",
  hierarchy: "Hierarchy",
  id: "ID",
  inactive: "Inactive",
  inactiveProducts: "Inactive products",
  incorporationDate: "Incorporation date",
  incorporationDateCompanyDocumentPopulated:
    "Incorporation date, company registration number and document number are all populated.", //?
  issuePayoutsToYourShoppersFromYourVoltConnectAccount:
    "Issue payouts to your shoppers from your Volt Connect account",
  learnMoreAboutVoltProducts:
    "Learn more about Volt products that we have in offer",
  legalName: "Legal name",
  listOfAllDependentCustomers: "List of all dependent customers ",
  manage: "Manage",
  manageAllYourEnabledProducts: "Manage all your enabled products",
  merchantCategoryCode: "Merchant Category Code",
  merchantCustomers: "Merchant customers",
  more: "+ {{numberOfInVisibleTags}} more",
  name: "Name",
  newCustomerCredentials:
    "New customer credentials for {{envName}} Environment",
  noAccountSelected: "No account selected",
  numDynamicBeneficiariesSelected: "{{count}} Dynamic Beneficiary selected",
  numDynamicBeneficiariesSelected_plural:
    "{{count}} Dynamic Beneficiaries selected",
  onlyUseInstantPaymentSchemes: "Only use instant payment schemes",
  open: "Open",
  ourAIStool: "Our AIS tool",
  ourBINRecognitionTool: "Our BIN recognition tool",
  ourCoreIntegration: "Our core integration",
  ourFraudPreventionTool: "Our fraud prevention tool",
  parent: "Parent",
  password: "Password",
  payByLink: "Pay by Link",
  payByLinkEnablesBusinessesToIntroduceOpenBankingPayments:
    "Pay by Link enables businesses to introduce open banking payments to all their communication channels with their customers. Clicking on the pre-generated link or scanning the QR code allows the customer to be redirected to Volt’s checkout page, where they can pay instantly using open banking-powered payments.",
  paymentConfiguration: "Payment configuration",
  paymentPreferences: "Payment preferences",
  paymentProviderConfigured:
    "Payment provider {{name}} has been configured for the customer.",
  paymentProviders: "Payment providers",
  paymentProviderUpdated:
    "Payment provider {{name}} has been updated for the customer.",
  payments: "Payments",
  paymentSchemes: "Payment Schemes",
  paymentsProviders: "Payments providers",
  payouts: "Payouts",
  payoutsIsAFastAndReliablePaymentProcessingSolution:
    "Payouts is a fast and reliable payment processing solution that enables businesses to send money to individuals with ease.",
  pleaseSelectParent:
    "Please select a parent to see the list of bank accounts this customer can inherit.",
  pleaseCopyAndSecurely:
    "Please copy and securely store the credentials, viewing the client password will not be possible after closing this popup.",
  postalCode: "Postal code",
  postalZIPCode: "Postal / ZIP Code",
  productFlagProductionModeHasBeenActivated:
    "{{productFlagName}} production mode has been activated",
  productFlagProductionModeHasBeenDeactivated:
    "{{productFlagName}} production mode has been deactivated",
  productFlagSandboxModeHasBeenActivated:
    "{{productFlagName}} sandbox mode has been activated",
  productFlagSandboxModeHasBeenDeactivated:
    "{{productFlagName}} sandbox mode has been deactivated",
  production: "Production",
  processOnlyInstantPaymentsVerifiedByVolt:
    "Process only instant payments Verified by Volt",
  provider: "Provider",
  provideValidBankCodes:
    "Provide valid bank codes to configure the list of allowed beneficiary banks.",
  refundPaymentsReceivedOnYourVoltConnectAccount:
    "Refund payments received on your Volt Connect account",
  refunds: "Refunds",
  regenerate: "Regenerate",
  regenerateCredentials: "Regenerate credentials",
  regenerateCustomerCredentials:
    "Regenerate customer credentials for {{envName}} Environment?",
  registerAtBEXS: "Register at BEXS",
  requiresSetup: "Requires Setup",
  reset: "Reset",
  retry: "Retry",
  sandbox: "Sandbox",
  save: "Save",
  saveChanges: "Save",
  select: "Select",
  selectBankAccountYouWishToReceiveMoney:
    "Select a bank account you wish to receive money to. Selecting a bank account outside Brazil will register this merchant’s bank account at BEXS and set the settlement to crossborder.",
  sendSecurePaymentLinks: "Send secure payment links",
  setActive: "Set Active",
  setInactive: "Set Inactive",
  settlementBankAccount: "Settlement bank account",
  settlementPreferencesUpdated: "Settlement preferences have been updated.",
  setUpDynamicBeneficiary: "Set up dynamic beneficiary",
  setupProvider: "{{provider}} - Setup",
  somethingWentWrong: "Something went wrong. Please try again later.",
  sort_code: "Sort Code",
  sortCode: "Sort code",
  state: "State",
  stateRegionProvince: "State / Region / Province",
  status: "Status",
  stopDeactivation: "Stop deactivation",
  street: "Street",
  swift: "Swift code (BIC)",
  theExistingCredentials:
    "The existing credentials will be invalidated immediately",
  thereAreMoreFiltersItems: "There is {{count}} more item",
  thereAreMoreFiltersItems_plural: "There are {{count}} more items",
  thisActionWillCauseToRegisterOnBEXS:
    "This action will cause us to register this customer and their bank accounts on BEXS. Please make sure that BEXS have already accepted this customer and allowed them before accepting.",
  thisAccountDeactivatingOn: "This account is deactivating on",
  thisCustomerDoesNotHaveDynamicTalkSupport:
    "This customer does not have any dynamic beneficiaries set up right now, talk to customer support team if you think there’s an issue",
  thisParentDoesntHaveBankAccountsAssigned:
    "This parent doesn’t have any bank accounts assigned.",
  transformer: "Transformer",
  transformerRecognisesAShopperBank:
    "Transformer recognises a shopper’s bank based on their debit or bank-issued credit card’s first six to eight digits (BIN). It’s then able to facilitate a ‘switch’ from a card payment to an open banking payment.",
  type: "Type",
  terminationDateCannotBeInThePast: "Termination date cannot be in the past",
  terminateImmediately: "Terminate immediately",
  thisCustomerDoesNotHaveAddress: "This customer doesn't have an address",
  thisCustomerDoesNotHaveAddressContactSupport:
    "This customer doesn't have an address, to add this information, please ",
  contactCustomerSupport: "contact customer support",
  onTerminationDateMerchantWillBeDeactivated:
    "On termination date merchant's account and all children accounts will be deactivated. The Merchant will no longer be able to process payments via Volt using API credentials. Fuzebox users will lose access to Fuzebox and transaction data so we suggest preparing transaction exports in advance.",
  unknown: "Unknown",
  username: "Username",
  verify: "Verify",
  verifyEnablesYouToSecurelyAccessCustomerBankAccounts:
    "Verify enables you to securely access customer bank accounts to confirm a user’s full name and account number. Compared to manual processes and working with unstructured data, it’s faster, more affordable and saves valuable time.",
  view: "View",
  voltAdminUser: "Volt admin user",
  voltGatewayOurCoreAPIisTheStartingPointForReceivingPaymentsOnYourWebsiteOrApp:
    "Volt Gateway, our core API, is the starting point for receiving payments on your website or app. Whether you’re planning to receive money direct to your own bank account, or use the power of Volt Connect, our cash management service, this is the first integration point.",
  weWereNotAbleToActivate:
    'We were not able to activate Token. The following error has been received: "AWAITING_APPROVAL". Please, contact Token Support.',
  youCanIssueARefundForEachPayment:
    "You can issue a refund for each payment received on your Volt Connect account. Refunds are available for up to a year from the original payment date. The refund will always be sent to the bank account that originated the payment and it will be sent from your current Volt Connect account in the currency of the payment.",
  yesSetActive: "Yes, Set Active",
  yesSetInactive: "Yes, Set Inactive",
  youCanOnlyAddUpTo:
    "You can only add up to {{maxBeneficiaries}} beneficiaries at a time",
  youDoNotHavePermissionToManage:
    "You do not have permission to manage bank accounts. Contact Volt administrator if you think there is an error.",
  youDoNotHavePermissionToViewOrManage:
    "You do not have permissions to view or manage bank accounts. Contact Volt administrator if you think there is an error.",
  youDontHaveAnyDynamicBeneficiariesGetStarted:
    "You don’t have any dynamic beneficiaries set up right now, let’s get started",
  yourAddressDataIsMissing:
    "Your address data is missing. Please contact Volt Support for more details.",
  youHaveUnsavedFilters: "You have unsaved filters",
};
